export default {
  header: 'Upraviť',
  general: {
    tabLabel: 'Všeobecné',
  },
  certificate: {
    tabLabel: 'Certifikáty',
    ams: {
      amsGroupLabel: 'AMS',
      pyrometry: {
        pyrometryCheckbox: 'AMS2750',
        furnaceClass: 'Trieda pece',
        instrumentationType: 'Typ inštrumentácie',
      },
      heatTreatmentOfSteelParts: 'AMS2759',
    },
    others: {
      objectthersGroupLabel: 'Ostatné',
      newCertificatesPlaceholder: 'nové ostatné certifikáty',
      instrumentationTypePlaceholder: 'Typ inštrumentácie',
    },
  },
  capability: {
    tabLabel: 'Možnosti',
    otherCapabilitiesPlaceholder: 'Ostatné možnosti',
    temperature: {
      temperatureGroupLabel: 'Teplota',
      maxTempLabel: 'Maximálna teplota',
      minTempLabel: 'Minimálna teplota',
    },
    dimensions: {
      dimensionsGroupLabel: 'Rozmery',
      diameterLabel: 'Priemer',
      widthLabel: 'Šírka',
      lengthLabel: 'Dĺžka',
      heightLabel: 'Výška',
      maxLoadLabel: 'Maximálne zaťaženie',
    },
  },
  statistics: {
    targetProductivityLabel: 'Cieľová produktivita',
  },
  settings: {
    tabLabel: 'Nastavenia',
    spanGap: 'Prah medzery časového radu',
  },
};
